import { FormControlLabel, Radio } from "@mui/material"
import T from "prop-types"
import { prop } from "ramda"
import { cx } from "ramda-extension/es"
import { createElement as h } from "react"

import * as css from "./css.js"

export const LabeledRadio = ({ checked, className, color, disabled, label, onChange, value, dataQa, ...props }) => {
  return h(FormControlLabel, {
    className,
    classes: css.useLabelStaticOverrides(),
    ["data-qa"]: dataQa ? `label-${dataQa}` : undefined,

    control: h(Radio, {
      inputProps:{
        ...props,
      },
      checked,
      className,

      classes: {
        checked: cx(
          prop("checked", css.useRadioStaticOverrides),
          prop("checked", css.useRadioDynamicOverrides({ color })),
          prop("disabled", css.useRadioDynamicOverrides({ checked, color })),
        ),

        root: cx(
          prop("root", css.useRadioStaticOverrides),
          prop("root", css.useRadioDynamicOverrides({ color })),
        ),
      },

      color: "default",
      disabled,
      onChange,
      value,
    }),

    label,
  })
}

LabeledRadio.propTypes = {
  checked: T.bool,
  className: T.string,
  color: T.string,
  disabled: T.bool,
  label: T.string,
  onChange: T.func,
  value: T.any,
}

LabeledRadio.defaultProps = {
  color: "primary",
}
